const WeChat = {
  url: 'https://mobile.jiahuiku.cn/getCode.html',
  // appid: 'wxa530b6522d23f5bc', // 新家风
  appid: 'wx062e3d167170faad', // 家慧库
  scope: 'snsapi_userinfo'
}

export default WeChat
